import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=70c5fb8e&scoped=true&"
import script from "./AreaChart.vue?vue&type=script&lang=js&"
export * from "./AreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5fb8e",
  null
  
)

export default component.exports